// @LTG-ID: data-sectors
// @STATUS: BUILT
// @HERMETIC: true
// @DOCS: 04b_SHARED_CONTRACT.md, 08_FEATURES.md#F-006
// @CHANGED: 2026-02 session_002
// @OWNER: web
//
// The canonical 11-sector enum. Ported verbatim from
// /app/source_reference/Landing Page.html lines 1510-1677.
// Each record carries an inline SVG icon (returned as JSX).
// `industryMultipleKey` references /app/frontend/src/data/industryMultiples.js.

import React from "react";

export const SECTORS = [
    {
        key: "trades",
        label: "Trades & Home Services",
        sublabel: "HVAC, plumbing, electrical, roofing, landscaping",
        industryMultipleKey: "construction",
        example: "Carolina Plumbing Co.",
        citation:
            "ServiceTitan benchmarks · Nexstar Network · GF Data · PKF O\u2019Connor Davies · Profitability Partners",
        icon: (
            <svg viewBox="0 0 32 32" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round">
                <path d="M20.5 6.5l5 5-3.5 3.5-2-2-8 8-2.5-2.5 8-8-2-2z" />
                <circle cx="9" cy="23" r="2" />
                <path d="M22 11l4 4" />
            </svg>
        ),
    },
    {
        key: "restaurants",
        label: "Restaurants & Food",
        sublabel: "Independent, multi-unit, franchised, bars, catering",
        industryMultipleKey: "restaurants",
        example: "Queen City Public House",
        citation:
            "Restaurant Finance Monitor · BizBuySell Restaurants · Auxo Capital Advisors · National Restaurant Association · We Sell Restaurants",
        icon: (
            <svg viewBox="0 0 32 32" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round">
                <path d="M9 4v14a3 3 0 003 3v7" />
                <path d="M9 9h3M9 14h3" />
                <path d="M21 4c-2 0-3 1.5-3 5s1 5 3 5" />
                <path d="M21 14v14" />
            </svg>
        ),
    },
    {
        key: "retail",
        label: "Retail",
        sublabel: "Specialty, hardware, jewelry, convenience",
        industryMultipleKey: "retail",
        example: "Triad Specialty Co.",
        citation:
            "NRF · BizBuySell Retail Insight · Retail Owners Institute · IBISWorld Retail",
        icon: (
            <svg viewBox="0 0 32 32" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round">
                <path d="M6 11h20l-1.5 14a2 2 0 01-2 2H9.5a2 2 0 01-2-2L6 11z" />
                <path d="M11 11V8a5 5 0 0110 0v3" />
            </svg>
        ),
    },
    {
        key: "auto",
        label: "Auto & Transportation",
        sublabel: "Auto repair, collision, car wash, dealerships, trucking",
        industryMultipleKey: "auto",
        example: "Westside Auto Service",
        citation:
            "NADA · KPMG Automotive Aftermarket · CCC Intelligent Solutions · Raymond James Car Wash Insight · ATA",
        icon: (
            <svg viewBox="0 0 32 32" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round">
                <path d="M5 19l2-6a3 3 0 013-2h12a3 3 0 013 2l2 6" />
                <path d="M4 19h24v5H4z" />
                <circle cx="9" cy="22" r="1.5" fill="currentColor" />
                <circle cx="23" cy="22" r="1.5" fill="currentColor" />
            </svg>
        ),
    },
    {
        key: "healthcare",
        label: "Healthcare Practices",
        sublabel: "Dental, veterinary, physician, optometry, PT, mental health",
        industryMultipleKey: "healthcare",
        example: "Westside Family Dental",
        citation:
            "FOCUS Investment Banking · McLerran & Associates · Henry Schein · Tusk Practice Sales · ADA HPI · Ackerman Group · VMG Health",
        icon: (
            <svg viewBox="0 0 32 32" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round">
                <path d="M16 7v18M7 16h18" />
                <rect x="5" y="5" width="22" height="22" rx="2" />
            </svg>
        ),
    },
    {
        key: "professional",
        label: "Professional Services",
        sublabel: "Law, accounting, consulting, RIA, insurance, engineering",
        industryMultipleKey: "prof_services",
        example: "Triad Family Law",
        citation:
            "Altman Weil · Citi Hildebrandt · Rosenberg Survey · Sica Fletcher · Reagan Consulting · MarshBerry · Mercer Capital · Advisor Growth Strategies",
        icon: (
            <svg viewBox="0 0 32 32" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round">
                <rect x="5" y="11" width="22" height="14" rx="1.5" />
                <path d="M12 11V8a2 2 0 012-2h4a2 2 0 012 2v3" />
                <path d="M5 17h22" />
            </svg>
        ),
    },
    {
        key: "manufacturing",
        label: "Manufacturing & Distribution",
        sublabel: "Machine shops, precision, food, printing, industrial",
        industryMultipleKey: "manufacturing",
        example: "Charlotte Sheet Metal Works",
        citation:
            "GF Data · BVR DealStats · MAPI · AMT · NTMA · PMA · Pitchbook Industrials · First Page Sage",
        icon: (
            <svg viewBox="0 0 32 32" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round">
                <path d="M5 26V14l6-4 6 4v-4l8 6v10z" />
                <path d="M5 26h22" />
                <rect x="9" y="18" width="3" height="4" />
                <rect x="17" y="18" width="3" height="4" />
            </svg>
        ),
    },
    {
        key: "personal",
        label: "Personal Services",
        sublabel: "Salons, spas, fitness, yoga, studios",
        industryMultipleKey: "personal",
        example: "Uptown Wellness Studio",
        citation:
            "IHRSA · Two-Brain Business · Mindbody industry reports · Professional Beauty Association",
        icon: (
            <svg viewBox="0 0 32 32" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="9" cy="22" r="3" />
                <circle cx="23" cy="22" r="3" />
                <path d="M11.5 20l9-13M20.5 20l-9-13" />
            </svg>
        ),
    },
    {
        key: "childcare",
        label: "Childcare & Education",
        sublabel: "Daycare, preschool, tutoring, driving, music",
        industryMultipleKey: "childcare",
        example: "Carolina Early Learning Academy",
        citation:
            "NAEYC · Childcare Aware · KinderCare benchmarks · Bright Horizons · National Center for Education Statistics",
        icon: (
            <svg viewBox="0 0 32 32" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round">
                <path d="M16 6L4 12l12 6 12-6-12-6z" />
                <path d="M9 15v5c0 2 3 4 7 4s7-2 7-4v-5" />
                <path d="M28 12v7" />
            </svg>
        ),
    },
    {
        key: "technology",
        label: "Technology",
        sublabel: "SaaS, MSPs, cybersecurity, e-commerce, digital agencies",
        industryMultipleKey: "saas",
        example: "Atlas Cloud Systems",
        citation:
            "Aventis Advisors MSP Reports · ConnectWise · Service Leadership Index · CompTIA · FOCUS IT Services",
        icon: (
            <svg viewBox="0 0 32 32" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round">
                <rect x="7" y="7" width="18" height="18" rx="2" />
                <rect x="11" y="11" width="10" height="10" />
                <path d="M3 12h4M3 16h4M3 20h4M25 12h4M25 16h4M25 20h4M12 3v4M16 3v4M20 3v4M12 25v4M16 25v4M20 25v4" />
            </svg>
        ),
    },
    {
        key: "other",
        label: "Other Sectors",
        sublabel: "Self-storage, laundromats, funeral, marina, equipment rental",
        industryMultipleKey: "prof_services",
        example: "Your business",
        citation:
            "Pepperdine PCMR (Dr. Craig R. Everett, Graziadio Business School) · BVR DealStats · BizBuySell Insight Report · IBBA Market Pulse · IBISWorld",
        icon: (
            <svg viewBox="0 0 32 32" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="9" cy="16" r="2" />
                <circle cx="16" cy="16" r="2" />
                <circle cx="23" cy="16" r="2" />
            </svg>
        ),
    },
];

export const DEFAULT_CITATION =
    "Benchmarks calibrated against Pepperdine Private Capital Markets Report (Dr. Craig R. Everett, Graziadio Business School), BVR DealStats, BizBuySell Insight Report, IBBA & M&A Source Market Pulse, EPI State of Owner Readiness 2023, and sector-specific data.";

export function getSector(key) {
    if (!key) return null;
    return SECTORS.find((s) => s.key === key) || null;
}

export const SECTOR_KEYS = SECTORS.map((s) => s.key);
